export default () => ({
  fullHeight: {
    height: '100%',

    '& .MuiCardContent-root': {
      height: '100%',
    },
  },
});
